export enum EMyEventType {
  TASK = 'TASK',
  EVENT = 'EVENT',
}
